export enum CardStatus {
    Inactive,
    Active,
    Blocked
}


// WEBPACK FOOTER //
// ./src/app/models/CardStatus.ts